import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';

export const calendarRoutes: Routes = [
  {
    path: 'calendar',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/pms-calendar/pms-calendar.component').then((m) => m.PmsCalendarComponent),
  },
];
